export default (t) => [
  {
    text: t('_delivery.Channel'),
    value: 'name',
    sortable: true,
    togglable: true
  },
  {
    text: t('_delivery.Type'),
    value: 'is_external',
    sortable: false,
    width: 120,
    togglable: true
  },
  {
    text: t('_delivery.GP %'),
    value: 'default_commission_rate',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('_delivery.Platform prices'),
    value: 'platform_product_count',
    sortable: false,
    width: 120,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 120,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 170
  },
];
